import { createReducer, Action, on } from '@ngrx/store';

import * as SoilAnalysisActions from './soil-analysis.actions';
import { SoilAnalysisState } from '../models/soil-analysis.model';

const reducer = createReducer<SoilAnalysisState>(
  {},
  on(SoilAnalysisActions.setSoilAnalyses, (state, { soilAnalyses }) => ({
    ...state,
    soilAnalyses,
  })),
  on(SoilAnalysisActions.showSoilAnalysisLayer, (state, { showSoilAnalysisLayer }) => ({
    ...state,
    showSoilAnalysisLayer,
  })),
  on(SoilAnalysisActions.selectSoilAnalysis, (state, { soilAnalysis }) => {
    if (soilAnalysis.borderData?.id) {
      return {
        ...state,
        selectedFeatureIds: [
          ...(state.selectedFeatureIds || []).filter((id) => id !== soilAnalysis.borderData?.id),
          soilAnalysis.borderData?.id,
        ],
      };
    } else {
      return state;
    }
  }),
  on(SoilAnalysisActions.selectSoilAnalysisFeature, (state, { featureId }) => ({
    ...state,
    selectedFeatureIds: [
      ...(state.selectedFeatureIds || []).filter((id) => id !== featureId),
      featureId,
    ],
  })),
  on(SoilAnalysisActions.deselectSoilAnalysisFeature, (state, { featureId }) => ({
    ...state,
    selectedFeatureIds: (state.selectedFeatureIds || []).filter((id) => id !== featureId),
  })),
  on(
    SoilAnalysisActions.deselectAllSoilAnalysisFeatures,
    (state) =>
      ({
        ...state,
        selectedFeatureIds: [],
      }) as SoilAnalysisState,
  ),
  on(SoilAnalysisActions.setDefaultSoilAnalyses, (state, { soilAnalyses }) => ({
    ...state,
    defaultSoilAnalyses: soilAnalyses
      ? [...soilAnalyses].sort((a, b) =>
          a.description.toLowerCase() > b.description.toLowerCase() ? 1 : -1,
        )
      : null,
  })),
  on(SoilAnalysisActions.setSoilAnalysisLoading, (state, { loading }) => ({
    ...state,
    isLoading: loading,
  })),
  on(SoilAnalysisActions.soilAnalysisLoadingComplete, (state) => ({
    ...state,
    isLoading: false,
  })),
);

export const soilAnalysisReducer = (state: SoilAnalysisState | undefined, action: Action) =>
  reducer(state, action);
